export const AUTHOR_TAGLINE_MAX = 80;
export const AUTHOR_BIO_MAX = 500;
export const AUTHOR_WEBSITE_MAX = 200;
export const DEFAULT_AUTHOR_ACCENT = 'sage';

export const AUTHOR_ACCENTS = {
    sage: { label: 'Sage', color: '#176b52' },
    coral: { label: 'Coral', color: '#b84a30' },
    ocean: { label: 'Ocean', color: '#1f6f9f' },
    plum: { label: 'Plum', color: '#7a4a8c' },
    amber: { label: 'Amber', color: '#9a5b0c' },
};

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUuid(value) {
    return typeof value === 'string' && UUID_PATTERN.test(value);
}

export function isAuthorAccent(value) {
    return typeof value === 'string' && Object.prototype.hasOwnProperty.call(AUTHOR_ACCENTS, value);
}

export function getAuthorAccentColor(accent) {
    return AUTHOR_ACCENTS[isAuthorAccent(accent) ? accent : DEFAULT_AUTHOR_ACCENT].color;
}

export function normalizeWebsite(value) {
    const trimmed = (value ?? '').trim();
    if (!trimmed) return { website: '', error: '' };

    let url;
    try {
        url = new URL(/^[a-z][a-z0-9+.-]*:/i.test(trimmed) ? trimmed : `https://${trimmed}`);
    } catch {
        return { website: trimmed, error: 'Enter a valid website address.' };
    }

    if (url.protocol !== 'https:') {
        return { website: trimmed, error: 'Website links must start with https://.' };
    }
    if (url.href.length > AUTHOR_WEBSITE_MAX) {
        return { website: trimmed, error: `Website links must be ${AUTHOR_WEBSITE_MAX} characters or fewer.` };
    }
    return { website: url.href, error: '' };
}

export function formatCount(value) {
    return (Number(value) || 0).toLocaleString();
}
